import React from 'react';
import IConfirmationBoxProps from '../entities/IConfirmationBoxProps';
import { BCModal, BCInput, IInputChangeEventArgs, findMessage } from '@bimser/components';
import Style from '../assets/confirmationBoxStyle.scss';

const ConfirmationBox = (props: IConfirmationBoxProps) => {
	const [text, setText] = React.useState('');
	const [reason, setReason] = React.useState('');

	const Strings = {
		BTN_OK: props.okButtonText ? props.okButtonText : findMessage.get('100013'),
		BTN_CANCEL: props.cancelButtonText ? props.cancelButtonText : findMessage.get('100034'),
		WARNING_TEXT: findMessage.get('101355'),
		REASON_WARNING_TEXT: findMessage.get('103036')
	};

	const isDisabled = () => {
		let disabled = false;

		if (props.validationValue) {
			disabled = props.validationValue !== text;
		}

		if (props.reasonRequired) {
			disabled = !reason;
		}

		return disabled;
	};

	function onTextChange(args: IInputChangeEventArgs) {
		setText(args.data);
	}

	function onReasonChange(args: IInputChangeEventArgs) {
		setReason(args.data);
	}

	function generateTemplate() {
		return (
			<>
				<span className={Style.ContentMessage}>{props.contentMessage}</span>
				{props.validationValue ? (
					<>
						<span className={Style.WarningMessage}>
							{Strings.WARNING_TEXT}
							<span className={Style.ConfirmationText}>{props.validationValue}</span>
						</span>
						<BCInput
							value={text}
							onChange={onTextChange}
						/>
					</>
				) : (
					''
				)}
				{props.reasonRequired ? (
					<>
						<span className={Style.WarningMessage}>{Strings.REASON_WARNING_TEXT}</span>
						<BCInput
							value={reason}
							onChange={onReasonChange}
						/>
					</>
				) : (
					''
				)}
			</>
		);
	}

	function handleOkClick() {
		props.onResolve({
			reason
		});
	}

	function handleCancelClick() {
		props.onReject(props.id);
	}

	return (
		<BCModal
			id={props.id}
			className={Style.ConfirmationBoxModal}
			modalContentWrapperCssClass={Style.ConfirmationBoxContainer}
			title={props.title}
			width="500px"
			visible
			handleOk={handleOkClick}
			handleCancel={handleCancelClick}
			okText={Strings.BTN_OK}
			cancelText={Strings.BTN_CANCEL}
			okButtonProps={{ disabled: isDisabled() }}
		>
			{generateTemplate()}
		</BCModal>
	);
};

export default ConfirmationBox;
